import { useToast } from "@/hooks/use-toast";
import { getTrialStatus } from "@/utils/trialUtils";

export const NOTIFICATION_THRESHOLDS = {
  CRITICAL: 3,
  WARNING: 7,
  REMINDER: 10
} as const;

export const useTrialNotifications = () => {
  const { toast } = useToast();

  const checkAndNotify = () => {
    const status = getTrialStatus();
    
    if (!status.isActive || status.hasExpired) return;

    const { daysRemaining } = status;

    if (daysRemaining <= NOTIFICATION_THRESHOLDS.CRITICAL) {
      toast({
        title: "Trial Ending Soon!",
        description: `Your trial expires in ${daysRemaining} days. Upgrade now to keep all features.`,
        variant: "destructive",
        duration: 10000,
      });
    } else if (daysRemaining <= NOTIFICATION_THRESHOLDS.WARNING) {
      toast({
        title: "Trial Update",
        description: `${daysRemaining} days remaining in your trial. Consider upgrading to maintain access.`,
        duration: 7000,
      });
    } else if (daysRemaining <= NOTIFICATION_THRESHOLDS.REMINDER) {
      toast({
        title: "Trial Status",
        description: `You have ${daysRemaining} days left in your trial period.`,
        duration: 5000,
      });
    }
  };

  return { checkAndNotify };
};